module.exports = __webpack_public_path__ + "components/flag/static/square/so-ba8566e6c374d3363035f8d74a43e023.svg";